export default __webpack_public_path__ + "static/media/arabic.37c594e8.svg";